import { render } from "./TableListFoot.vue?vue&type=template&id=415cafef"
import script from "./TableListFoot.vue?vue&type=script&lang=js"
export * from "./TableListFoot.vue?vue&type=script&lang=js"

import "./TableListFoot.vue?vue&type=style&index=0&id=415cafef&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__